<template>
  <div class="auth">
    <div class="header">
      <p class="title">{{ role.roleName }}</p>
      <p class="desc">{{ role.roleDesc }}</p>
    </div>
    <el-tabs v-model="dataType">
      <el-tab-pane
        v-for="item in tabs"
        :key="item.value"
        :label="$t(`stores::sync-log::${item.label}`)"
        :name="item.value"
      ></el-tab-pane>
    </el-tabs>
    <component :is="dataType" :roleId="role.roleId" :ref="dataType"></component>
  </div>
</template>

<script>
import menus from './components/auth/menu.vue'
import datas from './components/auth/data.vue'
import board from './components/auth/board.vue'
import model from './components/auth/model.vue'
export default {
  components: { menus, datas, board, model },
  props: {
    role: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      dataType: 'menus',
      tabs: [
        { label: this.$t('system::rbac::菜单功能权限'), value: 'menus' },
        { label: this.$t('system::rbac::数据权限'), value: 'datas' },
        { label: this.$t('system::rbac::看板权限'), value: 'board' },
        { label: this.$t('system::rbac::模型权限'), value: 'model' }
      ],
      loading: false
    }
  },
  methods: {
    // 切换角色的时候通过ref调用组件内方法
    search() {
      this.$refs[this.dataType].search()
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  ::v-deep {
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__item {
      height: 56px;
      line-height: 56px;
    }
    .el-tabs__nav-wrap::after {
      left: -24px;
      width: calc(100% + 48px);
      height: 1px;
      background-color: #dddddd;
    }
    .el-tabs__nav-wrap {
      position: static;
    }
  }
}
.header {
  margin-bottom: 16px;
  .title {
    font-weight: bold;
  }
  .desc {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
  }
}
</style>
